// extracted by mini-css-extract-plugin
export var loadingPlaceholder = "style-module--loading-placeholder--f0a7e";
export var spin = "style-module--spin--8fcf1";
export var spinner = "style-module--spinner--e25f1";
export var spinnerBlue = "style-module--spinner-blue--c9c72";
export var spinnerContainer = "style-module--spinner-container--3f83a";
export var spinnerWhite = "style-module--spinner-white--5a490";